import GamerLayout from '@layouts/gamer-layout/gamer-layout';
export default GamerLayout;
